import React from 'react';

export interface ApprovalCustomer {
  customerId?: string;
  name?: string;
  phoneNumber?: string;
  address?: string;
  area?: string;
  pincode?: string;
  aadhar?: string;
  pan?: string;
}

// The customer's contact and KYC details, shown to the admin on every approval
export default function ApprovalCustomerDetails({
  customer,
}: {
  customer?: ApprovalCustomer | null;
}): JSX.Element {
  if (customer == null) return <p>-</p>;
  const address = [customer.address, customer.area]
    .filter((part) => Boolean(part))
    .join(', ');
  const rows: Array<[string, string | undefined]> = [
    ['Name', customer.name],
    ['Customer ID', customer.customerId],
    ['Mobile', customer.phoneNumber],
    ['Address', address],
    ['PIN Code', customer.pincode],
    ['Aadhaar', customer.aadhar],
    ['PAN', customer.pan],
  ];
  return (
    <div style={{ textAlign: 'left', minWidth: 220 }}>
      {rows.map(([label, value]) => (
        <p key={label} style={{ margin: 0 }}>
          <strong>{label}:</strong> {value !== undefined && value !== '' ? value : '-'}
        </p>
      ))}
    </div>
  );
}
